import { DEFAULT_CROSSHAIR_OPTIONS } from 'ChartApp/ts/features/fundamental-chart/constants';
import { COPY_URL_LINK, DOWNLOAD, EMBED, EXPORT, PDF_FORMAT, PRINT, SHARE, TWEET, } from 'NewAngular/constants/core.constants';
import { FundChartAnnotationName } from 'ChartApp/ts/enums/fund-chart-common.enum';
import { FolderableAppType } from 'FoldersApp/enums/folderable-app-type.enum';
export const FUND_CHART_EXPORTING_OPTIONS = {
    title: {
        label: 'Export',
        icon: 'icon-export',
    },
    list: [
        { type: 'option', label: 'Export Data', value: EXPORT, icon: 'icon-csv' },
        { type: 'option', label: 'Download Image', value: DOWNLOAD, icon: 'icon-download' },
        { type: 'option', label: 'Print', value: PRINT, icon: 'icon-print' },
        { type: 'option', label: 'Download PDF', value: PDF_FORMAT, icon: 'icon-download' },
    ],
};
export const SAVED_FUND_CHART_SHARING_OPTIONS = {
    title: {
        label: 'Share',
        icon: 'icon-share',
    },
    list: [
        {
            type: 'option',
            label: 'Share with Team',
            value: SHARE,
            icon: 'icon-team',
        },
        {
            type: 'divider',
            label: null,
            value: null,
            icon: null,
        },
        {
            type: 'option',
            label: 'Tweet',
            value: TWEET,
            icon: 'icon-tweet',
        },
        {
            type: 'option',
            label: 'Embed Code',
            value: EMBED,
            icon: 'icon-embed',
        },
        {
            type: 'option',
            label: 'Copy Link',
            value: COPY_URL_LINK,
            icon: 'icon-link',
        },
    ],
};
// highcharts options for fund charts
export const FUND_CHART_PAGE_CONFIGURABLE_OPTIONS = {
    dynamicHeight: true,
    tooltipStyle: 'bar',
    showLatestValueLabels: true,
};
export const FUND_CHART_PAGE_CHART_OPTIONS = {
    xAxis: {
        crosshair: {
            ...DEFAULT_CROSSHAIR_OPTIONS,
        },
    },
    yAxis: {
        tickAmount: undefined,
        crosshair: {
            ...DEFAULT_CROSSHAIR_OPTIONS,
            width: 0,
        },
    },
};
// sharing urls
export const CHART_BASE_SHARING_URL_OPTIONS = {
    TWITTER: {
        url: '/charts/share_twitter/auth/fund/',
        width: 720,
        height: 780,
    },
};
export const FUND_CHART_ANNOTATION_KEY_TO_DISPLAY_NAME = {
    label: FundChartAnnotationName.TEXT,
    circle: FundChartAnnotationName.CIRCLE,
    rectangle: FundChartAnnotationName.RECTANGLE,
    segment: FundChartAnnotationName.TREND_SEGMENT,
    arrowSegment: FundChartAnnotationName.ARROW_SEGMENT,
    ray: FundChartAnnotationName.RAY,
    arrowRay: FundChartAnnotationName.ARROW_RAY,
    infinityLine: FundChartAnnotationName.LINE,
    arrowInfinityLine: FundChartAnnotationName.ARROW_LINE,
    parallelChannel: FundChartAnnotationName.PARALLEL_CHANNEL,
    horizontalLine: FundChartAnnotationName.HORIZONTAL_LINE,
    verticalLine: FundChartAnnotationName.VERTICAL_LINE,
};
export const DEFAULT_ANNOTATION_FONT_SIZE = '11';
export const DEFAULT_ANNOTATION_TEXT_COLOR = '#ffffff';
export const DEFAULT_ANNOTATION_FILL_COLOR = '#000000bf';
export const DEFAULT_ANNOTATION_LINE_WEIGHT = '1';
export const DEFAULT_ANNOTATION_LINE_COLOR = '#000000bf';
export const FUND_CHART_AI_CALC_NAME_MAP = {
    price: 'Price',
    total_return_forward_adjusted_price: 'Total Return Level',
    net_asset_value: 'Net Asset Value',
    level: 'Level',
};
export const FUND_CHART_FOLDERABLE_APP_CONFIG = {
    appName: 'SavedFundamentalChartApp',
    folderableAppType: FolderableAppType.MODAL,
    itemNamePlural: 'Saved Fundamental Charts',
};
